import React, { ReactNode, useEffect, useRef, useState } from 'react'
import './ResumenContent.css'
import { useResumenState } from '../ResumenContext'

const ResumenContent = ({ children }: { children: ReactNode }) => {
    const { footerHeight } = useResumenState()
    const [contentHeight, setcontentHeight] = useState<number | null>(null)
    const contentRef = useRef<HTMLDivElement>(null)
    useEffect(() => {
        if (contentRef.current && footerHeight) {
            setcontentHeight(contentRef.current.getBoundingClientRect().height - footerHeight)
        }
    }, [footerHeight])



    return (
        <div className='shared-resumen__content' ref={contentRef} style={{ height: contentHeight ? `${contentHeight}px` : "" }}>{children}</div>
    )
}

export default ResumenContent